// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"36ffacfc","239":"34829fd0","455":"399fe544"}[chunkId] + ".chunk.js";
};